import { withOData } from "@odata/withOData";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";

import Page, { IProps } from "../Page";
import { getDefinitions } from "./Chats.def";
import TicketsTableView from "./ChatsTableView";

class Chats extends Page<IProps> {
    static defaultProps = {
        getDef: getDefinitions,
        tableView: TicketsTableView,
        hasPreview: false
    };
}

export default withRouter(withTranslation([...getDefinitions.translationFiles])(withOData(Chats)));